import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import CekHargaL from './../assets/images/img_car01.png';
import CekHargaR from './../assets/images/img_car02.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import Line from '../components/Line';
import './../css/check_price.scss';
import CheckPriceTop from './../assets/images/check_price_top.png';
import CheckPriceBottom from './../assets/images/check_price_bottom.png';
import NumberFormat from 'react-number-format';
import Axios from 'axios';
import { Http } from '../constant/Http';
import { API_CHECK_PRICE } from '../api/api';
import Sidebar from '../components/Sidebar';
import TopNav from '../components/TopNav';
import Car from '../assets/images/wingr.png';

const CekPrice = () => {
  const history = useHistory();
  const [probability, setProbability] = useState();
  const [probabilityLevel, setProbabilityLevel] = useState();
  const [harga, setHarga] = useState({
    max: 0,
    min: 0,
  });

  const { selected, score } = useSelector((state) => state.checkPriceReducer);

  useEffect(() => {
    Axios.post(API_CHECK_PRICE.check_price, selected).then((res) => {
      const data = res.data.data;

      setHarga({ max: data.max_harga, min: data.min_harga });
    });
  }, []);

  const toRupiah = (number) => {
    if (typeof number !== 'undefined' && number !== null) {
      let separator;
      let number_string = number.toString(),
        sisa = number_string.length % 3,
        rupiah = number_string.substr(0, sisa),
        ribuan = number_string.substr(sisa).match(/\d{3}/g);

      if (ribuan) {
        separator = sisa ? '.' : '';
        rupiah += separator + ribuan.join('.');
      }

      return rupiah;
    }
  };

  const convertScore = (score) => {
    let converted = {};

    for (const sc in score) {
      if (score >= 85) {
        converted[sc] = 'A';
      } else if (score >= 84 && score <= 70) {
        converted[sc] = 'B';
      } else if (score <= 69) {
        converted[sc] = 'B';
      } else {
        converted[sc] = 'B';
      }
    }

    return converted;
  };

  const onProbability = (event) => {
    let data = selected;
    let data_score = convertScore(score);
    data.exterior = data_score.eksterior;
    data.interior = data_score.interior;
    data.mesin = data_score.mesin;
    data.rangka = data_score.rangka;
    data.harga_dasar = parseInt(event.value);
    data.score = score.eksterior + score.interior + score.mesin + score.rangka;
    delete data.eksterior;

    Axios.post(API_CHECK_PRICE.probability, data, Http)
      .then((res) => {
        const data = res.data.data;

        let level = '';

        if (data.probability >= 75) {
          level = 'Tinggi';
        } else if (data.probability <= 74 && data.probability >= 51) {
          level = 'Sedang';
        } else if (data.probability <= 50) {
          level = 'Rendah';
        } else if (data.probability <= 10) {
          level = 'Rendah';
        }

        setProbabilityLevel(level);
        setProbability(data.probability);
      })
      .catch((err) => {});
  };

  return (
    <>
      <div className="page-checkharga overview-page">
        <TopNav pageChannel="Cek Harga" />
        <div className="container-fluid main-overview">
          <div className="row">
            <Sidebar pageChannel="Cek Harga" />
            <div className="col-xl-10 col-lg-12 pt-3 content">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb ml-2">
                  <li className="breadcrumb-item">
                    <b>
                      <a
                        style={{ textDecoration: 'none', color: '#82be2a' }}
                        onClick={() =>
                          history.push({
                            pathname: '/',
                            state: {
                              pageChannel: 'Cek Harga',
                            },
                          })
                        }
                      >
                        Overview
                      </a>
                    </b>
                  </li>
                  <li className="breadcrumb-item">
                    <b>
                      <a href="/check-car" style={{ textDecoration: 'none', color: '#82be2a' }}>
                        Cek Harga Kendaraan
                      </a>
                    </b>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Hasil Pencarian
                  </li>
                </ol>
              </nav>
              <div className="row mx-4 py-4" style={{ backgroundColor: '#82be2a' }}>
                <div className="col-xl-3 pt-4 text-center">
                  <img src={CekHargaL} width="200" height="100" />
                </div>
                <div className="col-xl-6 py-4 text-center text-light">
                  <h6>Estimasi Harga Kendaraan Anda</h6>
                  <h3>
                    {selected.merk +
                      ' ' +
                      selected.seri +
                      ' ' +
                      selected.tipe +
                      ' ' +
                      selected.silinder +
                      ' ' +
                      selected.tahun}
                  </h3>
                </div>
                <div className="col-xl-3 pt-4 text-center">
                  <img src={CekHargaR} width="200" height="100" />
                </div>
              </div>
              <div className="row mt-2 py-4 mx-2">
                <div className="col-xl-7">
                  <div className="card float-left w-100 p-3">
                    <b>
                      <label>Harga Kendaraan Anda</label>
                    </b>
                    <label>Estimasi Harga Kendaraan Anda</label>
                    <b>
                      <span style={{ fontSize: '20px' }}>
                        Rp. {toRupiah(harga.min)} - Rp. {toRupiah(harga.max)}
                      </span>
                    </b>
                    <span className="p-2 mt-2 mb-4" style={{ fontSize: 10, backgroundColor: '#f1f7e3' }}>
                      <FontAwesomeIcon className="fa-info mr-1" icon={faExclamationCircle} />
                      Harga di atas adalah harga terbentuk/harga terjual kendaraan di IBID
                    </span>
                    <Line height={2} width="100%" color="#E6E4E4" />
                    <b>
                      <label className="mt-2">Masukan Harga Dasar Kendaraan</label>
                    </b>
                    <label style={{ fontSize: 12 }}>
                      Untuk mengetahui persentase terjualnya kendaraan, silahkan masukan harga dasar kendaraan
                    </label>
                    <div className="row">
                      <div className="col-xl-6">
                        <label style={{ fontSize: 14 }}>Harga Dasar Kendaraan</label>
                        <NumberFormat
                          decimalSeparator={','}
                          thousandSeparator={'.'}
                          prefix={'Rp.'}
                          placeholder="Rp. 80.000.000"
                          onValueChange={(event) => {
                            onProbability(event);
                          }}
                          className="form-control mb-3"
                          type="text"
                        />
                      </div>
                      <div className="col-xl-6">
                        <label style={{ fontSize: 14 }}>
                          Persentase Terjual : {probabilityLevel != undefined && probabilityLevel}
                        </label>
                        <div className="w-100" style={{ backgroundColor: '#82be2a', padding: 6 }}>
                          <span style={{ fontSize: 14, color: 'white' }}>
                            Presentase kendaraan terjual
                            <b>{probability != undefined && ` ${probability}%`}</b>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="info" style={{ fontSize: '12px', padding: '10px 10px 0px 10px' }}>
                      <span>Poin penting:</span>
                      <ul>
                        <li>1. Informasi hasil persentase terjual hanyalah simulasi</li>
                        <li>2. Hasil di atas adalah perkiraan harga tanpa penilaian langsung</li>
                        <li>3. Harga yang tertera berdasarkan kondisi mobil yang bagus</li>
                        <li>4. Kelengkapan dokumen juga menjadi salah satu faktor penentu harga</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-xl-5">
                  <div className="card w-100" style={{ height: '100%' }}>
                    <div className="card p-3" style={{ height: '50%' }}>
                      <div className="row">
                        <div className="col-xl-5">
                          <img src={CheckPriceTop} width="150" height="200" />
                        </div>
                        <div className="col-xl-7 m-auto">
                          <label style={{ fontSize: 13, fontWeight: 600 }}>
                            Ada yang Tertarik dengan Kendaraan Anda
                          </label>
                          <p style={{ fontSize: 11 }}>
                            5 orang tertarik dan ingin mengetahui lebih detail tentang kendaraan Anda, jangan lewatkan
                            kesempatan ini
                          </p>
                          <a
                            href="https://www.ibid.astra.co.id/titip-lelang"
                            target="_blank"
                            style={{
                              color: '#82be2a',
                              fontSize: 13,
                              fontWeight: 600,
                            }}
                          >
                            Pelajari Selengkapnya &#8594;
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="card p-3" style={{ height: '50%' }}>
                      <div className="row">
                        <div className="col-xl-5">
                          <img src={CheckPriceBottom} width="150" height="200" />
                        </div>
                        <div className="col-xl-7 m-auto">
                          <label style={{ fontSize: 13, fontWeight: 600 }}>
                            Butuh Hasil Estimasi yang Lebih Akurat?
                          </label>
                          <p style={{ fontSize: 11 }}>
                            Untuk mendapatkan estimasi harga kendaraan yang lebih akurat segera atur jadwal inspeksi
                            mobil sesuai dengan waktu dan lokasi yang diinginkan.
                          </p>
                          <a
                            href="https://acv.astra.co.id/"
                            target="_blank"
                            style={{
                              color: '#82be2a',
                              fontSize: 13,
                              fontWeight: 600,
                            }}
                          >
                            Pelajari Selengkapnya &#8594;
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-checkharga-mobile">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 pt-3 pb-2 d-flex px-4 align-items-center header">
              <FontAwesomeIcon
                onClick={() => {
                  history.replace({ pathname: '/', state: { pageChannel: 'Cek Harga' } });
                }}
                className="mb-2"
                icon={faArrowLeft}
              />
              <h4 className="ml-5" style={{ fontSize: '6vw' }}>
                Cek Harga Kendaraan
              </h4>
            </div>
          </div>
          <div className="row">
            <div
              className="col-12 d-flex flex-column align-items-center pt-3 pb-3 text-light header"
              style={{ backgroundColor: '#a3cf62' }}
            >
              <img src={Car} style={{ width: 200, height: 120 }} />
              <label className="mt-1">Estimasi Harga Kendaraan Anda</label>
              <h6 style={{ fontWeight: 700 }}>
                {selected.merk +
                  ' ' +
                  selected.seri +
                  ' ' +
                  selected.tipe +
                  ' ' +
                  selected.silinder +
                  ' ' +
                  selected.tahun}
              </h6>
            </div>
          </div>
          <div className="row mt-4 pt-2 pb-4 bg-light">
            <div className="col-12">
              <b>
                <label>Harga Kendaraan Anda</label>
              </b>
              <label className="text-secondary">Estimasi harga kendaraan anda adalah</label>
              <b>
                <label style={{ fontSize: '5vw' }}>
                  Rp. {toRupiah(harga.min)} - Rp. {toRupiah(harga.max)}
                </label>
              </b>
              <label className="p-3 mt-2 mb-4" style={{ fontSize: 13, backgroundColor: '#f1f7e3' }}>
                <FontAwesomeIcon className="fa-info mr-1" style={{ color: '#82be2a' }} icon={faExclamationCircle} />
                Harga di atas adalah harga terbentuk/harga terjual kendaraan dibalai lelang serasi (IBID)
              </label>
              <Line height={2} width="100%" color="#E6E4E4" />
              <b>
                <label className="mt-2">Masukan Harga Dasar Kendaraan</label>
              </b>
              <label style={{ fontSize: 12 }}>
                Untuk mengetahui persentase terjualnya kendaraan, silahkan masukan harga dasar kendaraan
              </label>
              <div className="row">
                <div className="col-12">
                  <label style={{ fontSize: 14 }}>Harga Dasar Kendaraan</label>
                  <NumberFormat
                    decimalSeparator={','}
                    thousandSeparator={'.'}
                    prefix={'Rp.'}
                    placeholder="Rp. 80.000.000"
                    onValueChange={(event) => {
                      onProbability(event);
                    }}
                    className="form-control mb-3"
                    type="text"
                  />
                </div>
                <div className="col-12">
                  <label style={{ fontSize: 14 }}>
                    Persentase Terjual : {probabilityLevel != undefined && probabilityLevel}
                  </label>
                  <div className="w-100" style={{ backgroundColor: '#82be2a', padding: 6 }}>
                    <span style={{ fontSize: 14, color: 'white' }}>
                      Presentase kendaraan terjual
                      <b>{probability != undefined && ` ${probability}%`}</b>
                    </span>
                  </div>
                </div>
              </div>
              <div className="info mt-3" style={{ fontSize: '12px', padding: '10px 10px 0px 10px' }}>
                <span>Poin penting:</span>
                <ul>
                  <li>1. Informasi hasil persentase terjual hanyalah simulasi</li>
                  <li>2. Hasil di atas adalah perkiraan harga tanpa penilaian langsung</li>
                  <li>3. Harga yang tertera berdasarkan kondisi mobil yang bagus</li>
                  <li>4. Kelengkapan dokumen juga menjadi salah satu faktor penentu harga</li>
                </ul>
              </div>
              {/* </div> */}
            </div>
          </div>
          <div className="row mt-4 bg-light pt-2 pb-4">
            <div className="col-12 d-flex flex-column align-items-center justify-content-center text-center">
              <img src={CheckPriceTop} style={{ width: '50%', height: '90%' }} />
              <h5 className="mt-4">Ada yang tertarik dengan kendaraan Anda</h5>
              <label>
                5 orang tertarik dan ingin mengetahui lebih detail dengan kendaraan anda, jangan lewatkan kesempatan
                ini.
              </label>
              <a
                href="#"
                className="mt-2"
                style={{
                  color: '#82be2a',
                  fontSize: 14,
                  fontWeight: 600,
                }}
              >
                Pelajari Selengkapnya &#8594;
              </a>
            </div>
          </div>
          <div className="row mt-4 bg-light pt-2 pb-4">
            <div className="col-12 d-flex flex-column align-items-center justify-content-center text-center">
              <img src={CheckPriceBottom} style={{ width: '50%', height: '90%' }} />
              <h5 className="mt-4">Butuh Hasil Estimasi Yang Lebih Akurat?</h5>
              <label>
                Untuk mendapatkan estimasi harga kendaraan yang lebih akurat segera atur jadwal inspeksi mobil sesuai
                dengan waktu dan lokasi yang diinginkan
              </label>
              <a
                href="#"
                className="mt-2"
                style={{
                  color: '#82be2a',
                  fontSize: 14,
                  fontWeight: 600,
                }}
              >
                Pelajari Selengkapnya &#8594;
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CekPrice;
